<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card vx-card">
        <div class="card-body" v-loading="loading">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <!-- <h4 class="font-weight-bold">Lista de artículos</h4> -->
              <registers-per-page
                @changeNumPerPage="changeNumPerPage"
              ></registers-per-page>
              <search-filter
                @executeSearch="search"
                :options="[]"
              ></search-filter>
            </div>
            <div class="row mt-5">
              <div class="col">
                <vs-button class="float-right mr-5" type="gradient" @click="newItem()">
                  <i class="fa fa-user-plus"></i>
                  Crear Producto
                </vs-button>
                <!-- <vs-button class="float-right mr-5" @click.prevent="downloadExcel()">
                  <i class="fa fa-file-excel mr-1"></i>
                  Exportar Excel
                </vs-button>
                <vs-button class="float-right mr-5" color="blue" @click="importExcel()">
                  <i class="fa fa-upload"></i>
                  Importar Productos
                </vs-button>
                <vs-button class="float-right mr-5" color="red" @click="deleteAll()">
                  <i class="fa fa-trash"></i>
                  Limpiar
                </vs-button> -->
              </div>
            </div>
          </div>

          <div
            id="data-list-list-view"
            class="data-list-container mt-5"
            v-if="items.length"
          >
            <vs-table ref="table" :max-items="perPage" :data="items">
              <template slot="thead">
                <vs-th>Imagen</vs-th>
                <vs-th>Código</vs-th>
                <vs-th>Cabys</vs-th>
                <vs-th>Nombre</vs-th>
                <vs-th>Categoría</vs-th>
                <vs-th>Marca</vs-th>
                <vs-th>Familia</vs-th>
                <vs-th>Precio</vs-th>
                <vs-th>Acciones</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr
                    :data="item"
                    :key="indextr"
                    v-for="(item, indextr) in data"
                  >
                    <vs-td>
                      <el-image
                        style="width: 50px; height: 50px; display: block"
                        :src="item.image"
                        fit="scale-down"
                      ></el-image>
                    </vs-td>
                    <vs-td>
                      {{ item.code }}
                    </vs-td>
                    <vs-td>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                          item.cabys_code
                            ? `${item.cabys_code.code} - ${item.cabys_code.name} - Impuesto: ${item.cabys_code.tax_rate}%`
                            : 'S/C'
                        "
                        placement="right"
                      >
                        <span>{{
                          item.cabys_code ? item.cabys_code.code : "S/C"
                        }}</span>
                      </el-tooltip>
                    </vs-td>

                    <vs-td>
                      {{ item.name | truncateText(0, 25) }}
                    </vs-td>

                    <vs-td>
                      {{ item.category.name }}
                    </vs-td>

                    <vs-td>
                      {{ item.brand ? item.brand.name : "S/C" }}
                    </vs-td>

                    <vs-td>
                      {{ item.family ? item.family.name : "S/C" }}
                    </vs-td>

                    <vs-td> {{ item.currency.symbol }} {{ item.price }} </vs-td>

                    <vs-td class="whitespace-no-wrap">
                      <el-dropdown @command="itemAction">
                        <i class="fa fa-cogs text-primary"></i>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            :command="{ action: 'edit', id: item.id }"
                            class="text-success"
                          >
                            <i class="fa fa-edit"></i>
                            Editar
                          </el-dropdown-item>
                          <el-dropdown-item
                            :command="{
                              action: 'delete',
                              payload: { id: item.id }
                            }"
                            class="text-danger"
                          >
                            <i class="fa fa-times"></i>
                            Eliminar
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>

            <div
              class="mt-4 text-center zatura-pagination"
              v-if="pageCount > 1"
            >
              <vs-pagination :total="pageCount" v-model="page"></vs-pagination>
            </div>
          </div>

          <div
            class="col-md-12 text-center"
            v-if="!loading && items.length == 0"
          >
            <p>No hay artículos.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- modal new item -->
    <vs-popup :fullscreen="true" title="Nuevo articulo" :active.sync="newItemModal2">
      <div
        class="col-md-12"
        v-loading="loading"
        element-loading-text="Guardando por favor espere"
      >
        <form @submit.prevent="storeItem()">
          <div class="row">
            <div class="card vx-card">
              <div class="card-header bg-white">
                <h4 class="">Información Artículo</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Código Cabys</label>
                      <el-select
                        placeholder=""
                        v-model="item.cabys_code"
                        value-key="id"
                        name="cabys_code"
                        filterable
                        class="form-control items"
                        popper-class="el-select-float"
                        data-vv-as="Código Cabys"
                        remote
                        :remote-method="searchCabysCodes"
                        :loading="loadingSearch"
                        @change="changeTaxType"
                      >
                        <el-option
                          v-for="cabys in cabysCodes"
                          :key="cabys.id"
                          :label="`${cabys.code}-${cabys.name}`"
                          :value="cabys"
                        >
                          <span style="font-weight: bold;">{{
                            cabys.code
                          }}</span
                          >-{{ cabys.name }}
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('cabys_code')" class="error">
                        {{ errors.first("cabys_code") }}
                      </label>
                    </div>

                    <text-input
                      name="code"
                      :label="'Código Interno'"
                      v-validate="'required'"
                      :error="errors.first('code')"
                      v-model="item.code"
                      data-vv-as="Código Interno"
                    >
                    </text-input>
                    <text-input
                      name="sku"
                      :label="'SKU'"
                      :error="errors.first('sku')"
                      v-model="item.sku"
                      data-vv-as="SKU"
                    >
                    </text-input>
                    <text-input
                      name="barcode"
                      :label="'Código de barras'"
                      :error="errors.first('barcode')"
                      v-model="item.barcode"
                      data-vv-as="Código de barras"
                    >
                    </text-input>
                    <text-input
                      name="reference"
                      :label="'Referencia'"
                      :error="errors.first('reference')"
                      v-model="item.reference"
                      data-vv-as="Referencia"
                    >
                    </text-input>
                    <text-input
                      name="name"
                      :label="'Nombre del Producto'"
                      v-validate="'required'"
                      :error="errors.first('name')"
                      v-model="item.name"
                      data-vv-as="Nombre del Producto"
                    >
                    </text-input>

                    <div class="form-group">
                      <label>Categoría</label>
                      <el-select
                        placeholder=""
                        v-model="item.category"
                        value-key="id"
                        name="category"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                        popper-class="el-select-float"
                      >
                        <el-option
                          v-for="category in categories"
                          :key="category.id"
                          :label="category.name"
                          :value="category"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('category')" class="error">
                        {{ errors.first("category") }}
                      </label>
                    </div>

                    <div class="form-group">
                      <label>Unidad</label>
                      <el-select
                        placeholder=""
                        v-model="item.unit"
                        value-key="id"
                        name="unit"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                        popper-class="el-select-float"
                      >
                        <el-option
                          v-for="unit in units"
                          :key="unit.id"
                          :label="unit.description"
                          :value="unit"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('unit')" class="error">
                        {{ errors.first("unit") }}
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>IVA</label>
                      <el-select
                        popper-class="el-select-float"
                        no-data-text="No hay datos."
                        no-match-text="No hay resultados."
                        placeholder=""
                        v-model="item.tax_type"
                        value-key="id"
                        name="tax_type"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                        @change="getUtility"
                      >
                        <el-option
                          v-for="tax_type in tax_types"
                          :key="tax_type.id"
                          :label="tax_type.name"
                          :value="tax_type"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('tax_type')" class="error">
                        {{ errors.first("tax_type") }}
                      </label>
                    </div>

                    <div class="form-group">
                      <label>Moneda</label>
                      <el-select
                        popper-class="el-select-float"
                        placeholder=""
                        no-data-text="No hay datos."
                        no-match-text="No hay resultados."
                        v-model="item.currency"
                        value-key="id"
                        name="currency"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                      >
                        <el-option
                          v-for="currency in currencies"
                          :key="currency.id"
                          :label="`${currency.name} (${currency.symbol})`"
                          :value="currency"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('currency')" class="error">
                        {{ errors.first("currency") }}
                      </label>
                    </div>

                    <text-input
                      name="cost_price"
                      :label="'Precio costo'"
                      v-validate="'decimal:2'"
                      :error="errors.first('cost_price')"
                      v-model="item.cost_price"
                      data-vv-as="Precio costo"
                      @change="getUtility"
                    >
                    </text-input>

                    <text-input
                      name="utility"
                      :label="'Utilidad (%)'"
                      v-validate="'decimal:2'"
                      :error="errors.first('utility')"
                      v-model="item.utility"
                      :disabled="true"
                      data-vv-as="Utilidad"
                    >
                    </text-input>

                    <text-input
                      name="price"
                      :label="'Precio sin IVA'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('price')"
                      v-model="item.price"
                      data-vv-as="Precio"
                      @change="getUtility"
                    >
                    </text-input>

                    <text-input
                      name="sale_price"
                      :label="'Precio Venta'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('sale_price')"
                      v-model="item.sale_price"
                      data-vv-as="Precio Venta"
                      @change="getPrice"
                    >
                    </text-input>

                    <text-input
                      name="max_discount"
                      :label="'Descuento Máximo (%)'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('max_discount')"
                      v-model="item.max_discount"
                      data-vv-as="Descuento Máximo"
                    >
                    </text-input>

                    <text-input
                      name="stock"
                      :label="'Existencia'"
                      :error="errors.first('stock')"
                      v-model="item.stock"
                      data-vv-as="Existencia"
                      :disabled="true"
                    >
                    </text-input>

                    <div class="form-group">
                      <label>Marca</label>
                      <el-select
                        popper-class="el-select-float"
                        placeholder=""
                        v-model="item.brand"
                        value-key="id"
                        name="brand"
                        filterable
                        class="form-control"
                      >
                        <el-option
                          v-for="brand in brands"
                          :key="brand.id"
                          :label="brand.name"
                          :value="brand"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('brand')" class="error">
                        {{ errors.first("brand") }}
                      </label>
                    </div>

                    <el-checkbox
                      v-show="item.category.id == 1"
                      v-model="item.has_inventory"
                      >Llevar inventario
                    </el-checkbox>

                    <el-checkbox v-model="item.active">Activo </el-checkbox>
                  </div>

                  <div class="col-md-12 text-center p-t-20">
                    <text-input
                      name="description"
                      :label="'Detalles'"
                      v-validate="'required'"
                      :error="errors.first('description')"
                      v-model="item.description"
                      data-vv-as="Detalles"
                      :textArea="true"
                    >
                    </text-input>

                    <vs-button button="submit" color="primary" type="filled">
                      <i class="fa fa-save"></i>
                      Guardar
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>
    <!-- end modal new item -->

    <!-- modal edit item -->
    <vs-popup :active.sync="editItemModal2" title="Editar articulo">
      <div
        class="col-md-12"
        v-loading="loading"
        element-loading-text="Guardando por favor espere"
      >
        <form @submit.prevent="updateItem()">
          <div class="row">
            <div class="card vx-card">
              <div class="card-header bg-white">
                <h4 class="">Información Artículo</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Código Cabys</label>
                      <el-select
                        placeholder=""
                        v-model="item.cabys_code"
                        value-key="id"
                        name="cabys_code"
                        filterable
                        class="form-control items"
                        popper-class="el-select-float"
                        data-vv-as="Código Cabys"
                        remote
                        :remote-method="searchCabysCodes"
                        :loading="loadingSearch"
                        @change="changeTaxType"
                      >
                        <el-option
                          v-for="cabys in cabysCodes"
                          :key="cabys.id"
                          :label="`${cabys.code}-${cabys.name}`"
                          :value="cabys"
                        >
                          <span style="font-weight: bold;">{{
                            cabys.code
                          }}</span
                          >-{{ cabys.name }}
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('cabys_code')" class="error">
                        {{ errors.first("cabys_code") }}
                      </label>
                    </div>
                    <text-input
                      name="code"
                      :label="'Código Interno'"
                      v-validate="'required'"
                      :error="errors.first('code')"
                      v-model="item.code"
                      data-vv-as="Código Interno"
                    >
                    </text-input>
                    <text-input
                      name="sku"
                      :label="'SKU'"
                      :error="errors.first('sku')"
                      v-model="item.sku"
                      data-vv-as="SKU"
                    >
                    </text-input>
                    <text-input
                      name="barcode"
                      :label="'Código de barras'"
                      :error="errors.first('barcode')"
                      v-model="item.barcode"
                      data-vv-as="Código de barras"
                    >
                    </text-input>
                    <text-input
                      name="reference"
                      :label="'Referencia'"
                      :error="errors.first('reference')"
                      v-model="item.reference"
                      data-vv-as="Referencia"
                    >
                    </text-input>
                    <text-input
                      name="name"
                      :label="'Nombre del Producto'"
                      v-validate="'required'"
                      :error="errors.first('name')"
                      v-model="item.name"
                      data-vv-as="Nombre del Producto"
                    >
                    </text-input>

                    <div class="form-group">
                      <label>Categoría</label>
                      <el-select
                        popper-class="el-select-float"
                        placeholder=""
                        v-model="item.category"
                        value-key="id"
                        name="category"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                      >
                        <el-option
                          v-for="category in categories"
                          :key="category.id"
                          :label="category.name"
                          :value="category"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('category')" class="error">
                        {{ errors.first("category") }}
                      </label>
                    </div>

                    <div class="form-group">
                      <label>Unidad</label>
                      <el-select
                        popper-class="el-select-float"
                        placeholder=""
                        v-model="item.unit"
                        value-key="id"
                        name="unit"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                      >
                        <el-option
                          v-for="unit in units"
                          :key="unit.id"
                          :label="unit.description"
                          :value="unit"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('unit')" class="error">
                        {{ errors.first("unit") }}
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>IVA</label>
                      <el-select
                        popper-class="el-select-float"
                        placeholder=""
                        v-model="item.tax_type"
                        value-key="id"
                        name="tax_type"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                        @change="getUtility"
                      >
                        <el-option
                          v-for="tax_type in tax_types"
                          :key="tax_type.id"
                          :label="tax_type.name"
                          :value="tax_type"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('tax_type')" class="error">
                        {{ errors.first("tax_type") }}
                      </label>
                    </div>

                    <div class="form-group">
                      <label>Moneda</label>
                      <el-select
                        popper-class="el-select-float"
                        placeholder=""
                        no-data-text="No hay datos."
                        no-match-text="No hay resultados."
                        v-model="item.currency"
                        value-key="id"
                        name="currency"
                        v-validate="'required'"
                        filterable
                        class="form-control"
                      >
                        <el-option
                          v-for="currency in currencies"
                          :key="currency.id"
                          :label="`${currency.name} (${currency.symbol})`"
                          :value="currency"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('currency')" class="error">
                        {{ errors.first("currency") }}
                      </label>
                    </div>

                    <text-input
                      name="cost_price"
                      :label="'Precio costo'"
                      v-validate="'decimal:2'"
                      :error="errors.first('cost_price')"
                      v-model="item.cost_price"
                      data-vv-as="Precio costo"
                      @change="getUtility"
                    >
                    </text-input>

                    <text-input
                      name="utility"
                      :label="'Utilidad (%)'"
                      v-validate="'decimal:2'"
                      :error="errors.first('utility')"
                      v-model="item.utility"
                      :disabled="true"
                      data-vv-as="Utilidad"
                    >
                    </text-input>

                    <text-input
                      name="price"
                      :label="'Precio sin IVA'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('price')"
                      v-model="item.price"
                      data-vv-as="Precio"
                      @change="getUtility"
                    >
                    </text-input>

                    <text-input
                      name="sale_price"
                      :label="'Precio Venta'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('sale_price')"
                      v-model="item.sale_price"
                      data-vv-as="Precio Venta"
                      @change="getPrice"
                    >
                    </text-input>

                    <text-input
                      v-if="item.inventory"
                      name="stock"
                      :label="'Existencia'"
                      :error="errors.first('stock')"
                      v-model="item.inventory.quantity"
                      data-vv-as="Existencia"
                      :disabled="true"
                    >
                    </text-input>

                    <text-input
                      v-else
                      name="stock"
                      :label="'Existencia'"
                      :error="errors.first('stock')"
                      v-model="item.stock"
                      data-vv-as="Existencia"
                      :disabled="true"
                    >
                    </text-input>

                    <text-input
                      name="max_discount"
                      :label="'Descuento Máximo (%)'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('max_discount')"
                      v-model="item.max_discount"
                      data-vv-as="Descuento Máximo"
                    >
                    </text-input>

                    <div class="form-group">
                      <label>Marca</label>
                      <el-select
                        popper-class="el-select-float"
                        placeholder=""
                        v-model="item.brand"
                        value-key="id"
                        name="brand"
                        filterable
                        class="form-control"
                      >
                        <el-option
                          v-for="brand in brands"
                          :key="brand.id"
                          :label="brand.name"
                          :value="brand"
                        >
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('brand')" class="error">
                        {{ errors.first("brand") }}
                      </label>
                    </div>

                    <el-checkbox
                      v-if="item.category.id == 1"
                      v-model="item.has_inventory"
                      >Llevar inventario
                    </el-checkbox>

                    <el-checkbox v-model="item.active">Activo </el-checkbox>
                  </div>

                  <div class="col-md-12 text-center p-t-20">
                    <text-input
                      name="description"
                      :label="'Detalles'"
                      v-validate="'required'"
                      :error="errors.first('description')"
                      v-model="item.description"
                      data-vv-as="Detalles"
                      :textArea="true"
                    >
                    </text-input>

                    <vs-button button="submit" color="primary" type="filled">
                      <i class="fa fa-save"></i>
                      Guardar
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>
    <!-- end modal edit item -->

    <new-item
      :vis="newItemModal"
      @closeModal="() => (newItemModal = false)"
      @refresh="refresh"
    ></new-item>

    <edit-item
      :vis="editItemModal"
      :default_item="item"
      @closeModal="() => (editItemModal = false)"
      @refresh="refresh"
    ></edit-item>

    <el-dialog title="Importar Excel" :visible.sync="importFileDialog">
    <el-alert
      :title="titleImport"
      type="warning"
      :closable="false"
      show-icon>
    </el-alert>
    <br>
    <el-upload
      class="upload-demo"
      :action="url_api"
      :headers="headerInfo"
      :limit="1"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      :auto-upload="false"
      :data="dataUpload"
      :on-exceed="handleExceed"
      :on-change="changeUploadImportFile"
      :on-remove="removeUploadImportFile"
      :before-upload="beforeUploadImportFile"
      :on-success="successUploadImportFile"
      :on-error="errorUploadImportFile"
      ref="upload">
      <div class="text-center">
        <el-button slot="trigger" size="small" type="primary">Selecciona un archivo</el-button>
        <div slot="tip" class="el-upload__tip">Solo archivos excel (xls/xlxs)</div>
      </div>
    </el-upload>
    <span slot="footer" class="dialog-footer">
      <el-button @click="importFileDialog = false">Cancelar</el-button>
      <el-button type="primary" :disabled="!importFileReady"  @click="uploadImportFile">Subir</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import itemsService from "@/services/items.service.js";
import brandsService from "@/services/brands.service.js";
import SearchFilter from "@/components/SearchFilter.vue";
import RegistersPerPage from "@/components/RegistersPerPage";
import { mapState, mapActions } from "vuex";
import Modal from "@/components/Modal.vue";
import utilitiesService from "@/services/utilities.service";
import NewItem from "./NewItem2.vue";
import EditItem from "./EditItem2.vue";
import Config from "@/config";
import helpers from "@/helpers/helpers";

export default {
  name: "items",
  data() {
    return {
      cabysCodes: [],

      items: [],
      loadingSearch: false,
      loading: true,
      pageCount: 1,
      perPage: 10,
      page: 1,
      searchData: {},
      item: {
        cabys_code: "",
        code: "",
        name: "",
        description: "",
        category: {id: 1, name: "Productos"},
        unit: {id: 37, name: "Unidad"},
        tax_type: "",
        price: "",
        currency: {id: 2, name: "Colones"},
        sku: "",
        barcode: "",
        reference: "",
        max_discount: "",
        brand: "",
        cost_price: "",
        sale_price: "",
        stock: "",
        utility: "",
        has_inventory: false,
        active: true
      },
      brands: [],
      newItemModal: false,
      newItemModal2: false,
      editItemModal: false,
      editItemModal2: false,
      importFileDialog: false,
      importFileReady: false,
      titleImport: "El archivo debe ser igual al excel que se exporta en este mismo módulo.",
      dataUpload: {
         import: "items"
      }
    };
  },
  computed: {
    ...mapState(["categories", "units", "tax_types", "currencies"]),
    categories() {
      return this.$store.state.categories;
    },
    units() {
      return this.$store.state.units;
    },
    tax_types() {
      return this.$store.state.tax_types;
    },
    currencies() {
      return this.$store.state.currencies;
    },
    url_logo() {
      return Config.url_files;
    },
    url_api() {
      return itemsService.uploadImportFile().url
    },
    headerInfo() {
      return itemsService.uploadImportFile().headers
    }
  },
  methods: {
    ...mapActions([
      "getCategories",
      "getUnits",
      "getTaxTypes",
      "getCurrencies"
    ]),
    changeNumPerPage(num) {
      let searchData = this.searchData;
      searchData.perPage = num;
      this.searchData = searchData;
      this.getItems(1, this.searchData);
    },
    search(search) {
      this.searchData = search;
      this.searchData.perPage = this.perPage;
      this.getItems(1, this.searchData);
    },
    deleteAll() {
      
      this.$confirm("¿ Deseas eliminar todos los productos ?", "Eliminar Productos", {
          confirmButtonText: "Si, continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
          center: true
        })
          .then(() => {
            this.loading = true;
            itemsService.deleteAllItems()
              .then(() => {
                this.loading = false;
                this.getItems(1, this.searchData);
                this.$message({
                  type: "success",
                  message: "Productos eliminados"
                });
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: "error",
                  message: "Ocurrio un problema"
                });
              });

          })
          .catch(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "Acción cancelada"
            });
          });
    },
    downloadExcel() {
      this.loading = true;
      this.searchData.export = 'excel'
      itemsService.getItems(0, this.searchData)
      .then(res => {
        delete this.searchData.export
        this.loading = false;
        helpers.downloadBlob(res.data, `lista-productos.xlsx`)
      }).catch(error => {
        delete this.searchData.export
        this.loading = false;
        this.$message({
          showClose: true,
          message: error.response.data.message,
          type: 'error'
        });
      })
    },
    importExcel() {
      this.titleImport = "El archivo debe ser igual al excel que se exporta en este mismo módulo.";
      this.importFileDialog = true
    },
    errorUploadImportFile(err) {
      this.loading = false
      this.$refs.upload.clearFiles()
      this.$message({
        showClose: true,
        message: `Ocurrio un error al subir el archivo`,
        type: 'error'
      });
    },
    successUploadImportFile(response) {
      if(response.success) {
        this.loading = false
        this.$refs.upload.clearFiles()
        this.getItems(this.currentPage, false, this.searchData)
        this.$message({
          showClose: true,
          message: 'Se ha cargado el archivo correctamente, espere mientras se actualizan los datos...',
          type: 'success'
        });
      }
    },
    beforeUploadImportFile() {
      this.loading = true
      this.importFileDialog = false
    },
    removeUploadImportFile() {
      this.importFileReady = false
    },
    changeUploadImportFile(file) {
      if(file)
        this.importFileReady = file.status == 'ready' ? true : false
      else 
        this.importFileReady = false
    },
    handleExceed() {
      this.$message.warning(`El límite de archivos es 1`);
    },
    uploadImportFile() {
      this.$refs.upload.submit();
    },
    getItems(page = 1, search = {}) {
      this.loading = true;

      itemsService
        .getItems(page, search)
        .then(res => {
          this.items = res.data.data;
          this.items.forEach(i => {
            if (i.image){
              i.image = this.url_logo + i.image;
            }
          });
          this.loading = false;
          this.pageCount = res.data.last_page;
        })
        .catch(error => {
          this.loading = false;
          if (error.response.status == 401) {
            // localStorage.clear();
            // this.$router.push('login');
          }
        });
    },
    getBrands(page = 0) {
      brandsService
        .getBrands(page)
        .then(res => {
          this.brands = res.data;
        })
        .catch(error => {
          this.loading = false;
          if (error.response.status == 401) {
            // localStorage.clear();
            // this.$router.push('login');
          }
        });
    },
    getPrice() {
      if (this.item.tax_type && this.item.sale_price != ""){
        let price = this.item.sale_price * 100 / (100 + this.item.tax_type.rate * 1);
        this.item.price = price.toFixed(2);
      }
    },
    getUtility() {
      if (this.item.tax_type && this.item.price != ""){
        let sale_price = (this.item.price * 1 + (this.item.price * this.item.tax_type.rate / 100));
        this.item.sale_price = sale_price.toFixed(2);
      }
      if (
        this.item.cost_price != "" &&
        this.item.cost_price > 0 &&
        this.item.price != ""
      ) {
        let result = (this.item.price / this.item.cost_price - 1) * 100;
        this.item.utility = result.toFixed(2);
      }
    },
    resetForm() {
      let data_form_initial = this.$options.data().item;
      Object.assign(this.$data.item, data_form_initial);
      this.$validator.reset();
    },
    newItem() {
      this.resetForm();
      this.newItemModal = true;
      //this.$router.push('new-item')
    },
    itemAction(command) {
      if (command.action == "edit") {
        //this.$router.push({name: 'edit-item', params: {id: command.id} });
        this.resetForm();
        this.getItemDetail(command.id);
        this.editItemModal = true;
      } else if (command.action == "delete") {
        this.$confirm("¿ Deseas eliminar el artículo ?", "Eliminar Artículo", {
          confirmButtonText: "Si, continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
          center: true
        })
          .then(() => {
            this.loading = true;
            let index = this.items.findIndex(i => i.id === command.payload.id);
            itemsService
              .deleteItem(command.payload.id)
              .then(() => {
                this.loading = false;
                this.items.splice(index, 1);
                this.$message({
                  type: "success",
                  message: "Artículo eliminado"
                });
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: "error",
                  message: "Ocurrio un problema"
                });
              });
          })
          .catch(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "Acción cancelada"
            });
          });
      }
    },
    goPage(numPage) {
      this.getItems(numPage, this.searchData);
    },
    refresh() {
      this.getItems(1, this.searchData);
      this.newItemModal = false;
    },
    storeItem() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.item.category.id != 1) {
            this.item.has_inventory = false;
          }
          let data = this.item;
          this.loading = true;
          itemsService
            .storeItem(data)
            .then(() => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: "Artículo Guardado correctamente",
                type: "success",
                duration: 1500
              });
              this.getItems(1, this.searchData);
              this.newItemModal = false;
            })
            .catch(function(error) {
              this.loading = false;
              //this.$snotify.error(error.response.data.message);
              //JRA Cambio de notificacion por mensaje
              this.$message({
                showClose: true,
                message: error.response.data.message,
                type: "error"
              });
            });
        }
      });
    },
    getItemDetail(id) {
      itemsService
        .getItemDetail(id)
        .then(res => {
          this.item = res.data.item;
          this.item.has_inventory = this.item.has_inventory == 1 ? true : false;
          this.item.active = this.item.active == 1 ? true : false;
          if (this.item.cabys_code) this.cabysCodes.push(this.item.cabys_code);
          this.getUtility();
        })
        .catch(error => {
          //this.$snotify.error(error.response.data.message);
          //JRA Cambio de notificacion por mensaje
          this.$message({
            showClose: true,
            message: error.response.data.message,
            type: "error"
          });
        });
    },
    updateItem() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loading = true;
          if (this.item.category.id != 1) {
            this.item.has_inventory = false;
          }
          let data = this.item;
          itemsService
            .updateItem(data)
            .then(() => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: "Artículo actualizado correctamente",
                type: "success",
                duration: 1500
              });
              this.getItems(1, this.searchData);
              this.editItemModal = false;
            })
            .catch(error => {
              this.loading = false;
              /*this.$notify({
              title: 'Error',
              message: error.message,
              type: 'error',
              duration: 1500
            });*/
              //JRA Cambio de notificacion por mensaje
              this.$message({
                showClose: true,
                message: error.message,
                type: "error",
                duration: 1500
              });
            });
        }
      });
    },
    getCategories() {
      this.$store.dispatch("getCategories", {});
    },
    getUnits() {
      this.$store.dispatch("getUnits", {});
    },
    getTaxTypes() {
      this.$store.dispatch("getTaxTypes", {});
    },
    getCurrencies() {
      this.$store.dispatch("getCurrencies", {});
    },
    searchCabysCodes(search) {
      this.loadingSearch = true;
      this.getCabysCodes(search);
    },
    //Get cabys codes
    getCabysCodes(search = false) {
      utilitiesService
        .getCabysCodes(search)
        .then(res => {
          this.loadingSearch = false;
          this.cabysCodes = res.data;
        })
        .catch(error => {
          this.loadingSearch = false;
          this.$message({
            showClose: true,
            message: error.response.data.message,
            type: "error"
          });
        });
    },
    changeTaxType(val) {
      let tt = this.tax_types.find(i => i.name == "Exento");
      if (val.tax_rate != "Exento") {
        tt = this.tax_types.find(i => i.rate == val.tax_rate);
      }
      this.item.tax_type = tt;
    }
  },
  watch: {
    page(newVal) {
      this.goPage(newVal);
    }
  },
  created() {
    this.getItems();
    this.getCategories();
    this.getUnits();
    this.getTaxTypes();
    this.getCurrencies();
    this.getCabysCodes();
    this.getBrands();
  },
  components: {
    SearchFilter,
    RegistersPerPage,
    Modal,
    NewItem,
    EditItem
  }
};
</script>

<style>
.box-shadow {
  box-shadow: 0 0 2px rgb(136, 124, 124) !important;
}

.oculto {
  display: none;
}

.con-vs-popup .vs-popup {
  width: 700px !important;
}

.el-select-dropdown__item {
  max-width: 600px;
  position: static;
  white-space: break-spaces;
  text-overflow: none;
  /* height: auto !important; */
  height: auto;
  max-height: 60px;
}
</style>
